<div class="menu-container about">
  <div class="line">
    <p [ghs-label]="'about.ip'"
      [ghs-label-args]="['<a href=\'https:\/\/cephalofair.com\' target=\'_blank\'>Cephalofair Games</a>']">
    </p>
  </div>
  <div class="line version">
    <a target="_blank" [href]="'https://github.com/Lurkars/gloomhavensecretariat/releases/tag/v' + version">Gloomhaven
      Secretariat
      v{{version}}</a>

    <div class="version-info">
      @if (!updateVersion) {
      <span class="unknown">
        <span [ghs-label]="'about.version.unknown'"></span>
      </span>
      }
      @if (!!updateVersion && updateVersion.latest) {
      <span class="latest">
        <span [ghs-label]="'about.version.latest'"></span>
      </span>
      }
      @if (!!updateVersion && !updateVersion.latest) {
      <span class="update">
        <span [ghs-label]="'about.version.update'" [ghs-label-args]="[updateVersion.version, updateVersion.url]"></span>
      </span>
      }
      @if (!updateVersion || !updateVersion.latest) {
      <a class="force" (click)="forceUpdate()"><span [ghs-label]="'about.forceUpdate'"></span></a>
      }
    </div>
  </div>

  <div class="line">
    <div class="columns">
      <div class="column">
        <p>
          <a href="https://ko-fi.com/lurkars" target="_blank"><span [ghs-label]="'about.support'"></span></a>
        </p>
      </div>
      <div class="column">
        <p><a href="https://github.com/Lurkars/gloomhavensecretariat" target="_blank"><span
              [ghs-label]="'about.sourceCode'"></span></a></p>
      </div>
      <div class="column">
        <p [ghs-label]="'about.license'"
          [ghs-label-args]="['<a href=\'https:\/\/\github.com\/Lurkars\/gloomhavensecretariat\/blob\/main\/LICENSE\'  target=\'_blank\'> AGPL3</a>']">
        </p>
      </div>
    </div>
  </div>
</div>